export const ALIVE_REASONS = {
  SUBSCRIBED: 'thread subscription status changed to subscribed',
  UNSUBSCRIBED: 'thread subscription status changed to unsubscribed',
}
